import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import BestBuyRankingListContainer, {
  BestBuyRankingListContainerProps,
} from "../BestBuyRankingList";
import { BestBuyRankingListItem } from "../BestBuyRankingList/BestBuyRankingList";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { testIds } from "./BestBuyModal.testIds";

export type BestBuyModalProps = Omit<
  BestBuyRankingListContainerProps,
  "onBestBuyItemsSelect"
> & {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onBestBuyItemsSubmit: (items: BestBuyRankingListItem[]) => void;
};

const BestBuyModal = ({
  open,
  loading,
  onClose,
  onBestBuyItemsSubmit,
  ...props
}: BestBuyModalProps) => {
  const { t } = useTranslation(["common", "orders"]);

  const [selectedBestBuyItems, setSelectedBestBuyItems] =
    useState<BestBuyRankingListItem[] | undefined>(undefined);

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      maxWidth="xl"
    >
      <DialogTitle>
        {t("orders:bestbuy.rankingTitle", "TrueSource Ranking")}
      </DialogTitle>
      <DialogContent
        sx={{
          width: 1000,
          height: 500,
        }}
      >
        <BestBuyRankingListContainer
          {...props}
          onBestBuyItemsSelect={(items) => setSelectedBestBuyItems(items)}
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton data-testid={testIds.bestBuyModalApply}
          variant="contained"
          loading={loading}
          onClick={() => {
            if (selectedBestBuyItems) {
              onBestBuyItemsSubmit(selectedBestBuyItems);
            } else {
              onClose();
            }
          }}
        >
          {t("common:apply", "Apply")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BestBuyModal;
